import { useEffect } from "react"
import Main from "./Main/Main"
import Upper from "./Upper"
import { getUser, selectUser, setUnauthorized, setUserGettingStatus } from "../user/userSlice"
import { useDispatch, useSelector } from "react-redux"
import { requireAuthentication } from "../authentication/authSlice"

const ProfilePage = () => {
  const dispatch = useDispatch()
  const user = useSelector(selectUser)
  const userGettingStatus = useSelector(state => state.user.statuses.uploading)
  const unauthorized = useSelector(state => state.user.unauthorized)

  useEffect(() => {
    dispatch(getUser())
  }, [dispatch])

  useEffect(() => {
    if (user && userGettingStatus !== "pending") {
        dispatch(setUnauthorized(false))
        dispatch(setUserGettingStatus(null))
      }
  }, [dispatch, user, userGettingStatus])

  useEffect(() => {
    if (unauthorized && !user && userGettingStatus === "rejected") {
      dispatch(requireAuthentication())
      dispatch(setUnauthorized(false))
      dispatch(setUserGettingStatus(null))
    }
  }, [dispatch, unauthorized, user, userGettingStatus])


  return (
    <div className="block max-w-xl border mx-auto p-4 shadow-2xl rounded-xl">
         
          <div className="mb-4">
              <Upper />
          </div>
          <Main />

        {userGettingStatus === "pending" && <div>Loading...</div>}
        {userGettingStatus === "rejected" && <div>Failed to get user</div>}
    </div>
  )
}

export default ProfilePage